import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from '../hooks/useReveal';
import { assets } from '../mock';

const LauraPage = () => {
  const { t } = useLanguage();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const l = t.laura;

  return (
    <main className="pt-24">
      <section className="section-pad bg-[#14120d]">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <Reveal>
              <div className="relative">
                <div className="absolute -top-4 -left-4 w-24 h-24 border-t border-l border-[#e6b83f]/50" />
                <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b border-r border-[#e6b83f]/50" />
                <img src={assets.lauraImage} alt="Laura Dickinson" className="w-full h-[460px] object-cover" />
              </div>
            </Reveal>
            <Reveal delay={120}>
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <span className="h-px w-8 bg-[#e6b83f]/60" />
                  <span className="font-sans-el text-[12px] tracking-[0.35em] uppercase text-[#e6b83f]">{l.eyebrow}</span>
                </div>
                <h1 className="font-deco text-4xl sm:text-5xl font-bold gold-gradient-text">{l.title}</h1>
                <p className="font-sans-el text-[13px] tracking-[0.25em] uppercase text-[#c2bbaa] mt-3">{l.role}</p>
                <p className="font-serif-el text-lg text-[#c9c2b3] mt-6 leading-relaxed">{l.p1}</p>
                <p className="font-serif-el text-lg text-[#c9c2b3] mt-4 leading-relaxed">{l.p2}</p>
                <Link to="/#contact" className="btn-gold inline-block mt-8 px-7 py-3.5 rounded-sm text-[13px] tracking-[0.2em] uppercase font-medium">
                  {l.cta}
                </Link>
              </div>
            </Reveal>
          </div>

          <Reveal delay={80}>
            <div className="relative mt-16 max-w-4xl mx-auto">
              <div className="aspect-video w-full overflow-hidden border border-[#e6b83f]/20 rounded-sm">
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/UhsYkyghRVM"
                  title="Laura Dickinson Live"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="max-w-4xl mx-auto mt-14">
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-8 bg-[#e6b83f]/60" />
                <span className="font-sans-el text-[12px] tracking-[0.3em] uppercase text-[#e6b83f]">{l.albumTitle}</span>
              </div>
              <div className="rounded-md overflow-hidden border border-[#e6b83f]/20">
                <iframe
                  title="Laura Dickinson Album"
                  src="https://open.spotify.com/embed/album/3GeK2NZ9brX0MCeNjAXolQ?utm_source=generator&theme=0"
                  width="100%"
                  height="352"
                  frameBorder="0"
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default LauraPage;
